import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ErgonomicWorkAnalysisKeyResultService } from '@/infra/services/ergonomic-work-analysis-key-result';
import { QUERY_KEYS } from '@/utils/query-keys';
import type { AxiosError } from 'axios';

interface BulkDeleteEWAStepKeyResultParams {
	organization_id: string;
	company_id: string;
	ergonomic_work_analysis_id: string;
	custom_report_step_key_ids: string[];
	custom_report_result_ids: string[];
}

const Service = ErgonomicWorkAnalysisKeyResultService.getInstance();

export const useBulkDeleteEWAStepKeyResults = () => {
	const queryClient = useQueryClient();

	return useMutation<any, AxiosError, BulkDeleteEWAStepKeyResultParams>({
		mutationFn: async (payload) => Service.bulkDelete(payload),
		onSuccess: async () => {
			await queryClient.invalidateQueries([QUERY_KEYS.GET_EWA_SELECTED_STEP_KEY_RESULTS]);
		},
		onError: (err: any) => {
			const errorMessage = err?.response?.data?.message;
			message.error(I18n.get(errorMessage || 'Ops... something happened!'));
		}
	});
};
